'use es6';

import { createSelector } from 'reselect';
import { makePermissionComponent } from 'ecosystem-marketplace-core/components/permissions';
import { debugGate } from '../utils/env';
import getLang from 'I18n/utils/getLang';

const getPortal = state => state.auth.portal;

const getUser = state => state.auth.user;

const getGates = state => state.auth.gates;

export const getIsUngated = createSelector([getGates], gates => gate => gates.includes(gate) || debugGate(gate));
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id)); // TODO update if public fetches auth info
// TODO account for admin preview

export const getIsPublic = createSelector([getIsCustomer], isCustomer => !isCustomer);
export const PublicOnly = makePermissionComponent(getIsPublic);
export const getLangCode = createSelector([getIsPublic, getUser], (isPublic, user) => isPublic ? getLang() : user.locale.slice(0, 2));
export const getUserFirstName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.first_name);
export const getUserLastName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
const getUserScopes = createSelector([getUser], user => user.scopes);
const getHasScope = createSelector([getUserScopes], scopes => scope => scopes.includes(scope));
export const getHasZorseChatScope = createSelector([getHasScope], hasScope => hasScope('zorse-chat'));
export const getHasZorseWebticketScope = createSelector([getHasScope], hasScope => hasScope('zorse-webticket'));
export const getPortalScopes = createSelector([getPortal], portal => portal.scopes);
const getIsUngatedForRatingFilter = createSelector([getIsUngated], isUngated => isUngated('Marketplace:filterByRating'));
export const RatingFilterGate = makePermissionComponent(getIsUngatedForRatingFilter);